define('jquery-dlmenu-patched',[
	'lodash',
	'lucid',
	'jquery',
	'jquery-dlmenu'
], function(
	_,
	lucidJS,
	$
) {
	var Translator = window.Translator;

	$.DLMenu.defaults.overviewLabel = Translator ? Translator.translate("Overview") : "Overview";
	$.DLMenu.defaults.backLabel = Translator ? Translator.translate("Back") : "Back";

	$.DLMenu.prototype._config = function() {
		var self = this;

		this.open = false;
		this.$trigger = this.$el.children( '.dl-trigger' );
		this.$menu = this.$el.children( 'ul.dl-menu' );
		this.$menuitems = this.$menu.find( 'li:not(.dl-back)' );
		this.$el.find( 'ul.dl-submenu' ).prepend( '<li class="dl-back"><a href="#">' + this.options.backLabel + '</a></li>' );
		this.$back = this.$menu.find( 'li.dl-back' );

		// Set the label text for the back link.
		if (this.options.useActiveItemAsBackLabel) {
			this.$back.each(function() {
				var $this = $(this),
					parentLabel = $this.parents('li:first').find('a:first').text();

				$this.find('a').html(parentLabel);
			});
		}
		// If the active item should also be a clickable link, create one and put
		// it at the top of our menu.
		if (this.options.useActiveItemAsLink) {
			// this.$el.find( 'ul.dl-submenu' ).prepend(function() {
			this.$back.after(function() {
				var parentli = $(this).parents('li:not(.dl-back):first').find('a:first'),
					altMobileTitle = $(this).parents('li:not(.dl-back):first').data('alt-title-mobile');

				if (altMobileTitle) {
					return '<li class="dl-parent"><a href="' + parentli.attr('href') + '">' + altMobileTitle +  '</a></li>';
				}
				else {
					return '<li class="dl-parent"><a href="' + parentli.attr('href') + '">' + parentli.text() + '</a></li>';
				}
				

			});
		}
	};

	var _openMenu = $.DLMenu.prototype._openMenu;
	$.DLMenu.prototype._openMenu = function() {
		var trigger = !this.open;

		_openMenu.apply(this, arguments);
		trigger && this.trigger('open');
	};

	var _closeMenu = $.DLMenu.prototype._closeMenu;
	$.DLMenu.prototype._closeMenu = function() {
		var trigger = this.open;

		_closeMenu.apply(this, arguments);
		trigger && this.trigger('close');
	};

	$.DLMenu.prototype = _.create(new lucidJS.EventEmitter, _.assign($.DLMenu.prototype, {
		'constructor': $.DLMenu
	}));

});
